/* eslint-disable */
const { getStaticAssetsPathPrefix } = require('../constant');
/**
 * webpack动态资源路径
 * @type {string}
 * @private
 */
__webpack_public_path__ = window.jdy_config.assets_endpoint + getStaticAssetsPathPrefix(PLATFORM_ENV);
